module.exports = __webpack_public_path__ + "static/img/vip.8f33f541.png";